// extracted by mini-css-extract-plugin
export default {"textHeadings":"AnimationText_textHeadings__MV8IN"};